import { Checkbox, DatePicker, FormField, FormFieldRow, MultiSelect, SingleSelect, Text, TextField } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import React from "react";

const options = [
	{
		id: "1",
		name: "Option 1",
	},
	{
		id: "2",
		name: "Option 2",
	},
	{
		id: "3",
		name: "Option 3",
	},
	{
		id: "4",
		name: "Option 4",
	},
] as ComponentItem[];

export default () => (
	<div
		style={{
			display: "inline-block",
			textAlign: "left",
		}}
	>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						name="textField"
					/>
				)}
				label={<Text bold res="Text Field" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						name="textField"
					/>
				)}
				invalidMessage="This is an example of an invalid message"
				label={<Text bold res="Invalid Text Field" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						fullWidth
						name="textField"
					/>
				)}
				fullWidth
				label={<Text bold res="Full Width Field" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormFieldRow>
				<FormField
					control={(
						<TextField
							autoFocus
							name="textField"
						/>
					)}
					label={<Text bold res="Text Field" />}
					labelPlacement="start"
				/>
				<FormField
					control={(
						<TextField
							autoFocus
							name="textField"
						/>
					)}
					label={<Text bold res="Text Field" />}
					labelPlacement="start"
				/>
			</FormFieldRow>
		</div>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						name="textField"
					/>
				)}
				label={<Text bold res="Label On Top" />}
			/>
		</div>
		<div>
			<FormField
				control={(
					<SingleSelect
						name="template"
						onChange={(event, newValueItem, reason) => console.log(newValueItem)}
						options={options}
						required
						style={{
							width: 352,
						}}
						value={options[0]}
					/>
				)}
				label={<Text bold res="Single Select" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormField
				control={(
					<MultiSelect
						onChange={(event, newValueItems, reason) => console.log(newValueItems)}
						options={options}
						style={{
							width: 352,
						}}
						value={[options[0]]}
					/>
				)}
				label={<Text bold res="Multi Select" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormField
				control={<Checkbox checked />}
				label={<Text bold res="Checkbox Field" />}
				labelPlacement="start"
			/>
		</div>
		<div>
			<FormField
				control={(
					<DatePicker
						disablePast
					/>
				)}
				label={<Text bold res="Date Field" />}
				labelPlacement="start"
			/>
		</div>
	</div>
);

